import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { QuotationCartService } from '@services/quotation.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';


@Injectable({ providedIn: 'root' })
export class QuotationGuard  {
    constructor(
        private router: Router,
        private quotationCartService: QuotationCartService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const quantity = this.quotationCartService.quantity;
        if (quantity > 0) {
            return true;
        } else {
            return this.quotationCartService.qCart$.pipe(map((data: any): any => {
                if (!_.isEmpty(data)) {
                    return true;
                }
                this.router.navigate(['/account/active-quotations']);
                return false;
            }))

        }
    }
}